import { render, staticRenderFns } from "./presentation1.vue?vue&type=template&id=c5c3f128&scoped=true"
import script from "./presentation1.vue?vue&type=script&lang=js"
export * from "./presentation1.vue?vue&type=script&lang=js"
import style0 from "./presentation1.vue?vue&type=style&index=0&id=c5c3f128&prod&scoped=true&lang=css"
import style1 from "./presentation1.vue?vue&type=style&index=1&id=c5c3f128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c3f128",
  null
  
)

export default component.exports